<template>
  <div
    class="relative dropdownContainer md:min-w-[140px]"
    :class="[props.id, selectContainerClass]"
  >
    <label v-if="props.label" class="block mb-[8px] title-16 text-primary-dark">
      {{ props.label }}
    </label>
    <div
      v-if="disabled"
      class="w-full relative flex items-center leading-[20px] text-[14px] min-h-[42px] cursor-pointer bg-[#F3F2F2] px-2.5 border border-secondary-light rounded-[6px]"
    >
      <!-- change input to div to prevent submitting -->
      <div
        v-if="!selectedOption"
        class="text-nowrap text-[14px] text-secondary-light font-normal pr-[30px] align-middle"
        :class="[hiddenOption ? 'text-primary-dark font-normal' : '']"
      >
        {{ props.placeholder }}
      </div>
      <div v-else class="">{{ selectedOption }}</div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="#DFDCDD"
        class="absolute end-3 top-1/2 -translate-y-1/2"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.6763 6.32372C17.1079 6.75536 17.1079 7.45517 16.6763 7.8868L10.7815 13.7815C10.3499 14.2132 9.65009 14.2132 9.21846 13.7815L3.32372 7.8868C2.89209 7.45517 2.89209 6.75536 3.32372 6.32372C3.75536 5.89209 4.45517 5.89209 4.8868 6.32372L10 11.4369L15.1132 6.32372C15.5448 5.89209 16.2446 5.89209 16.6763 6.32372Z"
          fill="#DFDCDD"
        />
      </svg>
    </div>

    <div
      v-if="!disabled"
      ref="selectRef"
      class="relative flex items-center leading-[20px] text-[14px] min-h-[42px] cursor-pointer bg-white px-2.5 border border-grey-light rounded-[6px]"
      :class="[inputClass, error ? '!border-[#EB5554]' : '']"
      @click="toggleDropdown($event)"
    >
      <!-- searchable input -->
      <input
        v-if="props.searchable"
        v-model="searchQuery"
        @input="onInput"
        type="text"
        :placeholder="inputPlaceholder"
        :class="[
          'placeholder-input text-nowrap align-middle label-L bg-transparent border-none outline-none w-full pr-8 truncate',
          !searchQuery ? props.placeholderClass : 'text-primary-dark',
        ]"
      />

      <!-- กรณีไม่ searchable และยังไม่เลือก -->
      <div
        v-else-if="!selectedOption"
        class="text-nowrap text-[14px] font-normal pr-[30px] align-middle overflow-hidden text-ellipsis whitespace-nowrap"
        :class="[
          props.placeholderClass,
          hiddenOption ? '!text-primary-dark font-normal' : '',
        ]"
      >
        {{ props.placeholder }}
      </div>

      <!--  กรณี :searchable="false" และเลือกแล้ว -->
      <span
        v-else
        class="text-nowrap align-middle text-[#1F1D1F] label-L min-w-[140px] overflow-hidden text-ellipsis pr-5"
        :class="[hiddenOption ? 'text-primary-dark' : '']"
      >
        {{ selectedOption }}
      </span>

      <!-- hover:bg-gray-100 -->
      <button
        v-if="props.searchable && (selectedOption || searchQuery)"
        type="button"
        class="absolute end-3 top-1/2 -translate-y-1/2 p-1 rounded"
        @click.stop="clearSelection"
        aria-label="Clear selection"
      >
        <!-- X icon -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M6 6l8 8M14 6l-8 8"
            stroke="#555055"
            stroke-width="1.8"
            stroke-linecap="round"
          />
        </svg>
      </button>

      <div
        v-else-if="!hideCaret"
        class="caret-down absolute end-3 top-1/2 -translate-y-1/2 duration-200"
        :class="dropdownIsOpened ? 'rotate-180' : ''"
      >
        <!-- caret icon -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.6763 6.32372C17.1079 6.75536 17.1079 7.45517 16.6763 7.8868L10.7815 13.7815C10.3499 14.2132 9.65009 14.2132 9.21846 13.7815L3.32372 7.8868C2.89209 7.45517 2.89209 6.75536 3.32372 6.32372C3.75536 5.89209 4.45517 5.89209 4.8868 6.32372L10 11.4369L15.1132 6.32372C15.5448 5.89209 16.2446 5.89209 16.6763 6.32372Z"
            fill="#555055"
          />
        </svg>
      </div>

      <Teleport to="body">
        <div
          v-if="dropdownIsOpened"
          ref="dropdownRef"
          :id="`dropdown-${instanceId}`"
          class="dropdown bg-white rounded-[6px] overflow-hidden"
          :class="optionClass"
          :style="dropdownStyle"
          @click.stop
        >
          <ul>
            <!-- <li v-if="filteredOptions.length <= 0"
              class="label-L !text-[#B7B2B5] text-center px-[10px] py-[8px] cursor-not-allowed">
              ไม่พบข้อมูล
            </li> -->
            <li
              v-for="(option, key) of filteredOptions"
              :key="key"
              :id="option.id"
              class="label-L p-[10px]"
              :class="[
                'hover:bg-soft-pink',
                isOptionDisabled(option)
                  ? 'opacity-50 cursor-not-allowed'
                  : 'cursor-pointer',
                option.hidden ? 'hidden' : '',
              ]"
              @click="!isOptionDisabled(option) && handleOnChange(option)"
              :hidden="hideChiangRai ? option.id === 46 : false"
            >
              <span v-if="typeof option === 'string'">{{ option }}</span>
              <span v-else-if="typeof option === 'object'">
                <span>{{ option[props.optionToDisplay] }}</span>
              </span>
            </li>
            <li
              v-if="props.searchable && filteredOptions?.length === 0"
              class="label-L !text-[#B7B2B5] px-[10px] py-[8px]"
            >
              ไม่พบข้อมูล
            </li>
          </ul>
        </div>
      </Teleport>
    </div>
    <small class="textError label-M absolute -bottom-5">{{
      Array.isArray(error) ? error[0] : error
    }}</small>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed, onUnmounted } from "vue";
import provinceData from "@/assets/json/provinces.json";
import districtData from "@/assets/json/districts.json";
import subDistrictData from "@/assets/json/subdistricts.json";
import { useDropdownManager } from "@/composables/useDropdownManager";

const emit = defineEmits(["update:modelValue", "change"]);
const props = defineProps({
  selectContainerClass: String,
  id: {
    required: false,
    default: null,
  },
  hideCaret: {
    default: false,
    type: Boolean,
  },
  label: "",
  placeholder: "โปรดเลือก",
  options: Array,
  error: null,
  inputClass: "",
  optionToDisplay: {
    type: String,
    default: "name",
  },
  valueKey: {
    type: String,
    default: "",
  },
  modelValue: [String, Object, Number],
  provinceCode: "",
  disabled: Boolean,
  districtCode: {
    type: [String, Number],
    default: "",
  },
  hiddenOption: Boolean,
  hideChiangRai: Boolean,
  deleteable: {
    type: Boolean,
    default: false,
  },
  placeholderClass: {
    type: String,
    default: "text-secondary-light",
  },
  searchable: {
    type: Boolean,
    default: false,
  },
  optionClass: {
    type: String,
    require: false,
  },
  removable: {
    type: Boolean,
    default: false,
  },
});

const instanceId = ref(Math.random().toString(36).substring(2, 11));

// Use dropdown manager for coordinated dropdown behavior
const { registerDropdown } = useDropdownManager();
const {
  isOpen: dropdownIsOpened,
  toggleDropdown: toggle,
  closeDropdown,
} = registerDropdown(instanceId.value);

const dropdownPosition = ref({ top: 0, left: 0, width: 0 });

const dropdownRef = ref(null);
const selectRef = ref(null);
const selectedOption = ref(null);
const searchQuery = ref("");

const updateDropdownPosition = () => {
  if (selectRef.value) {
    const rect = selectRef.value.getBoundingClientRect();
    dropdownPosition.value = {
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
      width: rect.width,
    };
  }
};

const dropdownStyle = computed(() => ({
  position: "absolute",
  top: `${dropdownPosition.value.top}px`,
  left: `${dropdownPosition.value.left}px`,
  width: `${dropdownPosition.value.width}px`,
  zIndex: 9999,
}));

const toggleDropdown = (event) => {
  event?.stopPropagation();
  if (!dropdownIsOpened.value) {
    updateDropdownPosition();
  }
  toggle();
};

const options = computed(() => {
  if (props.id === "provinceSelector") {
    return props.removable
      ? [{ provinceNameTh: props.placeholder }, ...provinceData]
      : provinceData;
  } else if (props.id === "districtSelector") {
    const filtered = districtData.filter(
      (d) => d.provinceCode == props.provinceCode
    );
    return props.removable
      ? [{ districtNameTh: "แสดงทุกอำเภอ", districtCode: null }, ...filtered]
      : filtered;
  } else if (props.id === "subdistrictSelector") {
    !!props.districtCode ? "" : (selectedOption.value = "");
    const filtered = subDistrictData.filter(
      (sub) => sub.districtCode == props.districtCode
    );
    return props.removable
      ? [
          { subdistrictNameTh: "แสดงทุกตำบล", subdistrictCode: null },
          ...filtered,
        ]
      : filtered;
  }
  return props.removable
    ? [
        { id: null, [props.optionToDisplay]: props.placeholder },
        ...props.options,
      ]
    : props.options;
});

// const getOptionLabel = (option) =>
//   typeof option === "object" ? option.label : option;

const handleSelection = (option) => {
  // console.log(option);
  // if (props.id == "districtSelector" && option.districtCode === null) {
  //   selectedOption.value = "";
  //   emit("update:modelValue", option);
  //   emit("resetSubdistrict", "");
  //   return;
  // }
  if (typeof option === "string") {
    selectedOption.value = option;
    emit("update:modelValue", option);
    if (props.searchable) searchQuery.value = option;
  } else if (typeof option === "object") {
    selectedOption.value = option[props.optionToDisplay] || "";
    emit("update:modelValue", option[props.valueKey] || "");
    if (props.searchable) searchQuery.value = option[props.optionToDisplay];
  }
};

const handleOnChange = (option) => {
  if (isOptionDisabled(option)) return; // กันอีกรอบ
  emit("change", option);
  handleSelection(option);
  closeDropdown();
};

const filteredOptions = computed(() => {
  if (!props.searchable || !searchQuery.value) return options.value;
  return options.value.filter((option) => {
    const label =
      typeof option === "object" ? option[props.optionToDisplay] : option;
    return label.toLowerCase().includes(searchQuery.value.toLowerCase());
  });
});

const inputPlaceholder = computed(() =>
  !selectedOption.value || searchQuery.value === "" ? props.placeholder : ""
);

const handleOutsideClick = (event) => {
  const dropdownElement = document.getElementById(
    `dropdown-${instanceId.value}`
  );

  if (
    selectRef.value &&
    !selectRef.value.contains(event.target) &&
    dropdownElement &&
    !dropdownElement.contains(event.target)
  ) {
    closeDropdown();
  }
};

const clearSelection = () => {
  selectedOption.value = "";
  searchQuery.value = "";
  // เคลียร์ modelValue ออกไป (เลือกใช้ null หรือ "" ตามที่ระบบมึงต้องการ)
  emit("update:modelValue", null);
  // optional: แจ้ง change เป็น null เผื่อฝั่งพ่อจะ reset อะไรต่อ
  emit("change", "");
  // ปิดดรอปดาวน์ด้วย (กันค้าง)
  closeDropdown();
};

// FIXED: Handle window events
const handleWindowEvents = () => {
  if (dropdownIsOpened.value) {
    updateDropdownPosition();
  }
};

onMounted(() => {
  document.addEventListener("click", handleOutsideClick);
  window.addEventListener("scroll", handleWindowEvents, true);
  window.addEventListener("resize", handleWindowEvents);
});

onUnmounted(() => {
  document.removeEventListener("click", handleOutsideClick);
  window.removeEventListener("scroll", handleWindowEvents, true);
  window.removeEventListener("resize", handleWindowEvents);
});

watch(
  [() => props.modelValue, () => props.id],
  ([newVal, newId]) => {
    if (newVal === null || newVal === undefined) {
      selectedOption.value = "";
      if (props.searchable) {
        searchQuery.value = "";
      }
      return;
    }
    const matched = options.value?.find((opt) => {
      if (typeof opt === "object") {
        if (props.valueKey) {
          return opt[props.valueKey] === newVal;
        }
        return (
          opt[props.valueKey] === newVal ||
          opt.id === newVal ||
          opt.value === newVal
        );
      } else {
        return opt === newVal;
      }
    });
    if (matched) {
      handleSelection(matched);
      if (props.searchable) {
        searchQuery.value = matched[props.optionToDisplay];
      }
    } else {
      // If no match found, clear the selection
      selectedOption.value = "";
      // console.warn(
      //   `No matching option found for value: ${newVal} in component: ${newId}`
      // );
    }
  },
  { immediate: true }
);

const onInput = (e) => {
  if (e.target.value === "") {
    selectedOption.value = "";
    emit("update:modelValue", null);
    emit("change", null);
  }
};



// check disabled
const isOptionDisabled = (option) =>
  typeof option === "object" &&
  (option.disable === 1 || option.disabled === true);
</script>

<style scoped lang="scss">
.dropdown {
  position: absolute;
  width: 100%;
  margin-top: 5px;
  top: 25px;
  left: 0;
  z-index: 100;
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.25);
  overflow: auto;
  max-height: 200px;
  padding: 4px;

  li {
    border-radius: 4px;
    color: var(--color-primary-dark);
  }
}

.placeholder-input::placeholder {
  color: #dfdcdd;
  //#b7b2b5
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.1px;
}
</style>
